import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { NgIdleModule } from '@ng-idle/core';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    NgIdleModule.forRoot()
  ],
  declarations: [
    NavbarComponent
  ],
  exports: [
    NavbarComponent
  ]
})

export class NavbarModule { }
